import { createContext, useContext, useState } from "react";

const DashboardModalsContext = createContext();

export const DashboardModalsProvider = ({ children }) => {
  const [orderView, setOrderView] = useState(false);
  return (
    <DashboardModalsContext.Provider value={{ orderView, setOrderView }}>
      {children}
    </DashboardModalsContext.Provider>
  );
};

export const useDashboardModals = () => {
  return useContext(DashboardModalsContext);
};
